import DocumentRepository from "../Repository/DocumentRepository";
import Document from "../Entity/Document";
import DocumentResourceRepository from "../Repository/DocumentResourceRepository";
import DocumentDownload from "../Entity/DocumentDownload";
import DocumentResource from "../Entity/DocumentResource";
import DocumentDownloadFactory from "../Factory/DocumentDownloadFactory";

export default class GetDocumentPendingDownload {
    public constructor(
        private readonly documentRepository: DocumentRepository,
        private readonly documentResourceRepository: DocumentResourceRepository,
        private readonly documentDownloadFactory: DocumentDownloadFactory
    ) {
    }

    public get(sessionToken: string): DocumentDownload[] {
        const documents: Document[] = this.documentRepository.getPendingDownload();
        const documentsOrdered: Document[] = this.orderByPosition(documents);
        const pendingDownloads: DocumentDownload[] = [];

        for (const document of documentsOrdered) {
            const documentDownload: DocumentDownload | null = this.create(document, sessionToken);
            if (documentDownload instanceof DocumentDownload) {
                pendingDownloads.push(documentDownload);
            }
        }

        return pendingDownloads;
    }

    private orderByPosition(documents: Document[]): Document[] {
        return documents.sort(
            (firstDocument, secondDocument): number => {
                return firstDocument.getPosition() - secondDocument.getPosition()
            }
        );
    }

    private create(document: Document, sessionToken: string): DocumentDownload | null {
        const id: number = parseInt(document.getId());
        const documentResource: DocumentResource | null = this.documentResourceRepository.getByDocumentReference(id);
        if (documentResource instanceof DocumentResource) {
            return this.documentDownloadFactory.create(
                documentResource.getResourceId(),
                document,
                sessionToken
            );
        }

        return null
    }
}